import Api from './api';

const DiarioService = {
    cadastro: async (params) => {
        const response = await Api.post('/restrito/diario/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/diario/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    numDiarios: async (params) => {
        return Api({
            method: 'get',
            url: '/restrito/diario/numdiarios',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    deletar: (id) => {
        Api.delete(`/restrito/diario/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    diarioEdit: async (id) => {
        const response = await Api.get(`/restrito/diario/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/diario/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/diario/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    arquivo: async (id, ano, params) => {
        const response = await Api.patch(`/restrito/diario/editar/${id}?ano=${ano}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    }
}

export default DiarioService;